import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const alarmsApi = createApi({
  reducerPath: 'alarmsApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['AlarmHistory', 'PendingAlarms'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    getAlarmHistoryPaginated: builder.query({
      query: ({ limit, offset, search }) => ({
        url: '/getAlarmHistoryPaginated',
        params: {
          limit,
          offset,
          ...(search ? { search: `"${search}"` } : {}), // Only include search param if it's provided
        },
      }),
      providesTags: ['AlarmHistory'], // Tells RTK Query this query provides 'AlarmHistory' data and to refetch when invalidated
    }),
    getPendingAlarmsPaginated: builder.query({
      query: ({ limit, offset, search }) => ({
        url: '/getPendingAlarmsPaginated',
        params: {
          limit,
          offset,
          ...(search ? { search: `"${search}"` } : {}), // Only include search param if it's provided
        },
      }),
      providesTags: ['PendingAlarms'], // Tells RTK Query this query provides 'PendingAlarms' data and to refetch when invalidated
    }),
    getPendingAlarms: builder.query({
      query: () => ({
        url: '/getPendingAlarms',
      }),
      transformResponse: (response) => response.data, // Extract the data array from the response
      providesTags: ['PendingAlarms'], // Tells RTK Query this query provides 'PendingAlarms' data and to refetch when invalidated
    }),
    acknowledgeAlarm: builder.mutation({
      query: (alarmIds) => ({
        url: '/acknowledgeAlarm',
        method: 'POST',
        data: { alarmIds },
      }),
      invalidatesTags: ['PendingAlarms'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    silenceAlarm: builder.mutation({
      query: (alarmIds) => ({
        url: '/updateSilence',
        method: 'POST',
        data: { alarmIds },
      }),
      invalidatesTags: ['PendingAlarms'], // Tells RTK Query to refetch any queries that provide this tag
    }),
  }),
});

export const {
  useGetAlarmHistoryPaginatedQuery,
  useGetPendingAlarmsPaginatedQuery,
  useGetPendingAlarmsQuery,
  useAcknowledgeAlarmMutation,
  useSilenceAlarmMutation,
} = alarmsApi;
